import * as R from 'ramda';
import React from 'react';

import {formatPercent, translate} from 'iss/strings';
import {minimumGradeValue} from 'iss/service/GradingScaleService';

/** A widget providing info about the effects of different reporting styles
 * and grades on the quality assurance reports for evaluation events
 * Used on the grade editor page.
 **/
function GradingScaleReportingInfo({id, gradingScale, reportingStyle, aimedGrade, minQualityPercent, maxQualityPercent}) {
  const grades = gradingScale ? gradingScale.grades : [];
  const error = getCalculationError({gradingScale, reportingStyle, aimedGrade, minQualityPercent, maxQualityPercent});

  return <div className="table-responsive">
    <p>
      {translate('widgets.GradingScaleReportingInfo.explanation')}
      {aimedGrade && translate('widgets.GradingScaleReportingInfo.aimedGradeIsHilighted')}
    </p>
    <table id={id} className="table table-bordered">
      <tbody>
        <tr>
          <th>{translate('widgets.GradingScaleReportingInfo.grade')}</th>
          {grades.map(grade =>
            <th key={grade.id} className={aimedGrade && grade.id == aimedGrade.id ? "info" : null}>{grade.text}</th>)}
        </tr>
        <tr>
          <th>{translate(
            reportingStyle == 'GRADE_AVERAGE' ?
            'widgets.GradingScaleReportingInfo.value' :
            'widgets.GradingScaleReportingInfo.percent'
          )}</th>
          {error && <td colSpan={grades.length | 1} className="danger">{error}</td>}
          {!error && grades.map(grade =>
            <td key={grade.id} className={aimedGrade && grade.id == aimedGrade.id ? "info" : null}>
              {getReportValue(grade, {gradingScale, reportingStyle, aimedGrade, minQualityPercent, maxQualityPercent})}
            </td>)}
        </tr>
      </tbody>
    </table>
  </div>;
}

function getCalculationError({gradingScale, reportingStyle, aimedGrade, minQualityPercent, maxQualityPercent}) {
  switch(reportingStyle) {
    case "SUCCESS_PERCENTAGE":
      if (!aimedGrade) {
        return translate('widgets.GradingScaleReportingInfo.noAimedGrade');
      }
      return null;
    case "QUALITY_PERCENTAGE": {
      if (!aimedGrade) {
        return translate('widgets.GradingScaleReportingInfo.noAimedGrade');
      }
      if (notNumeric(minQualityPercent)) {
        return translate('widgets.GradingScaleReportingInfo.noMinQualityPercent');
      }
      if (notNumeric(maxQualityPercent)) {
        return translate('widgets.GradingScaleReportingInfo.noMaxQualityPercent');
      }
      const minimumValue = minimumGradeValue(gradingScale);
      const aimedValue = aimedGrade.numericValue;
      if (aimedValue == minimumValue) {
        return translate('widgets.GradingScaleReportingInfo.aimedGradeIsLowest');
      }
      return null;
    }
    default:
      return null;
  }
}

function getReportValue(grade, {gradingScale, reportingStyle, aimedGrade, minQualityPercent, maxQualityPercent}) {
  switch(reportingStyle) {
    case "SUCCESS_PERCENTAGE":
      return grade.id == aimedGrade.id ? "100%" : "0%";
    case "QUALITY_PERCENTAGE": {
      const minimumValue = minimumGradeValue(gradingScale);
      const aimedValue = aimedGrade.numericValue;
      const barePercentage = (grade.numericValue - minimumValue) / (aimedValue - minimumValue);
      const minP = parseFloat(minQualityPercent);
      const maxP = parseFloat(maxQualityPercent);
      const percentage = ((maxP-minP) * barePercentage + minP);
      return formatPercent(percentage);
    }
    case "GRADE_AVERAGE":
    default:
      return grade.numericValue;
  }
}

const notNumeric = R.pipe(parseFloat, isNaN);

export default GradingScaleReportingInfo;



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/GradingScaleReportingInfo.jsx